import { compose } from 'shared/utils/function.utils';
import { getProductDetailReducer } from './get-product-detail';

export const extraReducers = compose(getProductDetailReducer);

export { getProductDetailAction } from './get-product-detail';
